export type ContactSearchStatus = 'ok' | 'too_many' | 'refinement_required' | 'query_too_short';

export interface ContactSearchRefinement {
  countryRequired?: boolean;
  stateRequired?: boolean;
  cityRequired?: boolean;
}

export interface ContactSearchResponse {
  status: ContactSearchStatus;
  message?: string;
  results: import('../types').UserSearchResult[];
  matchCount: number;
  returnedCount: number;
  refinement?: ContactSearchRefinement;
}

export function countLetters(value: string): number {
  return [...value].filter((ch) => /[a-zA-Z]/.test(ch)).length;
}

export function meetsContactSearchMinimum(term: string): boolean {
  const raw = term.trim();
  if (!raw) {
    return false;
  }

  if (raw.includes(',') || raw.includes(' ')) {
    let firstPart: string;
    let lastPart: string;
    if (raw.includes(',')) {
      const commaParts = raw.split(',', 2).map((p) => p.trim());
      lastPart = commaParts[0] ?? '';
      firstPart = commaParts[1] ?? '';
    } else {
      const spaceIndex = raw.indexOf(' ');
      firstPart = raw.slice(0, spaceIndex).trim();
      lastPart = raw.slice(spaceIndex + 1).trim();
    }
    if (!firstPart || !lastPart) {
      return false;
    }
    const firstLetters = countLetters(firstPart);
    const lastLetters = countLetters(lastPart);
    return firstLetters >= 2 && lastLetters >= 2 && firstLetters + lastLetters >= 4;
  }

  return countLetters(raw) >= 4;
}

export function getContactSearchValidationMessage(term: string): string | null {
  if (!term.trim()) {
    return 'Enter at least 4 letters, then press Enter to search.';
  }
  if (meetsContactSearchMinimum(term)) {
    return null;
  }
  if (term.includes(',') || term.includes(' ')) {
    return 'For first and last name, use at least 2 letters in each part (4 letters total), then press Enter.';
  }
  return 'Enter at least 4 letters, then press Enter to search.';
}

export function isContactSearchResponse(value: unknown): value is ContactSearchResponse {
  return Boolean(value && typeof value === 'object' && 'status' in value && 'results' in value);
}
